import { Marker } from '..';
import { CoordinatesUtil } from '../../../../util/coordinates.util';

export namespace MarkerUtil {
  const ZOOM_FOR_SINGLE_MARKER = 14;

  const MAX_DISTANCE_BETWEEN_TWO_POINTS = 180;
  const ZOOM_CORRECTION_FACTOR = 24;
  const getZoomByLargestDistanceFromCenter = (largestDistanceFromCenter: number) => {
    return MAX_DISTANCE_BETWEEN_TWO_POINTS / (largestDistanceFromCenter + ZOOM_CORRECTION_FACTOR);
  };

  export function getInitialMapState(markers: Marker[]) {
    const coordinates = markers.filter(m => m.coordinates).map(m => m.coordinates!);

    if (coordinates.length === 0) {
      return { zoom: 1 };
    }

    if (coordinates.length === 1) {
      return { zoom: ZOOM_FOR_SINGLE_MARKER, center: [coordinates[0].longitude, coordinates[0].latitude] };
    }

    if (coordinates.length > 1) {
      const center = CoordinatesUtil.getCenter(coordinates);
      const largestDistanceFromCenter = CoordinatesUtil.getLargestDistanceFromCenter(coordinates, center);
      return {
        zoom: getZoomByLargestDistanceFromCenter(largestDistanceFromCenter),
        center: [center.longitude, center.latitude],
      };
    }

    return { zoom: 1 };
  }
}
